// @flow

import { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { getPrivateDomain } from '@alphaott/app-main/selectors'
import { getPublicIp } from '@alphaott/api-client/devices'

export function usePublicIP() {
  const [ip, setIp] = useState(null)
  const privateDomain = useSelector(getPrivateDomain)

  const handleGetPublicIp = useCallback(async (domain) => {
    const response = await getPublicIp(domain)

    if (response.ok) {
      setIp(response?.data?.ip)
    }
  }, [])

  useEffect(() => {
    if (privateDomain) {
      handleGetPublicIp(privateDomain)
    }
  }, [privateDomain]) // eslint-disable-line react-hooks/exhaustive-deps

  return ip
}

export default usePublicIP
